import { render } from "./Meigaranews2list.vue?vue&type=template&id=4e0d13c8&scoped=true"
import script from "./Meigaranews2list.vue?vue&type=script&lang=js"
export * from "./Meigaranews2list.vue?vue&type=script&lang=js"

import "./Meigaranews2list.vue?vue&type=style&index=0&id=4e0d13c8&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0d13c8"]])

export default __exports__